import { ProjectList } from "@/components/project-list";

export default function ProjectsPage() {
  return <ProjectList />;
}
